import React, { useEffect, useState } from "react";
import Sidebar from "../../CoustamComponent/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import { alertErrorMessage, alertSuccessMessage } from "../../../Services/CustomAlertModel";
import LoaderHelper from "../../../Services/Loading/LoaderHelper";
import AuthService from "../../../Services/ApiServices/AuthService";

const Withdraw = () => {
  const [isActiveStep, setIsActiveStep] = useState("step1");
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(0);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const emailId = sessionStorage.getItem('emailId');

  const [formData, setFormData] = useState({
    chain: "BEP20",
    withdrawAddress: "",
    amount: "",
    userPin: "",
    verificationCode: "",
    chainAddress: "0xFA3BeD8E8bfa20de9F84e9eb038d1A893ff1fEf2",
  });

  const handleInput = (event) => {
    const { name, value } = event.target;
    if (name === "userPin") {
      if (value.length <= 4) {
        setFormData((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      } else {
        alertErrorMessage("Pin cannot exceed 4 digits");
      }
    } else if (name === "verificationCode") {
      if (value.length <= 6) {
        setFormData((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      } else {
        alertErrorMessage("Verification code cannot exceed 6 digits");
      }
    } else if (name === 'chain') {
      let chainAddress = "";
      if (value === "ERC20") {
        chainAddress = "0xFA3BeD8E8bfa20de9F84e9eb038d1A893ff1fEf2";
      } else if (value === "TRC20") {
        chainAddress = "TJgogFVGtjyHiJks26c9YJXR714NWFjexY";
      } else if (value === "BEP20") {
        chainAddress = "0xFA3BeD8E8bfa20de9F84e9eb038d1A893ff1fEf2";
      }
      setFormData(prevState => ({
        ...prevState,
        [name]: value,
        chainAddress
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const handleNextStep = () => {
    if (!formData?.chain) {
      alertErrorMessage("Please select a chain");
      return;
    } if (!formData?.withdrawAddress) {
      alertErrorMessage("Please Enter Withdraw Address");
      return;
    } if (!formData?.amount) {
      alertErrorMessage("Please Enter an amount");
      return;
    } if (!formData?.userPin) {
      alertErrorMessage("Please Enter PIN Number");
      return;
    } if (formData?.userPin.length !== 4) {
      alertErrorMessage("PIN must be exactly 4 digits");
      return;
    } if (!formData?.verificationCode) {
      alertErrorMessage("Please Enter a verification code");
      return;
    }
    setIsActiveStep("step2");
  };

  const handleGetOtp = async (type) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getOtp(type, emailId);
      LoaderHelper.loaderStatus(false);
      if (result?.success) {
        alertSuccessMessage(result?.message);
        setIsOtpSent(true);
        setCountdown(60);
      } else {
        alertErrorMessage(result);
        setIsOtpSent(false);
        setCountdown(0);
      };
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      alertErrorMessage(error);
    }
  };

  useEffect(() => {
    let timer;
    if (isOtpSent && countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
    } else if (countdown === 0) {
      setIsOtpSent(false);
    }
    return () => clearInterval(timer);
  }, [isOtpSent, countdown]);

  const handleWithdrawal = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.withdrawAmount(formData);
      LoaderHelper.loaderStatus(false);
      if (result?.success) {
        alertSuccessMessage(result?.message);
        navigate('/withdrawal_history');
      } else {
        alertErrorMessage(result);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      alertErrorMessage(error);
    }
  };

  return (
    <div className="wrapper dashboard_page ">
      <div className="page-body d-flex align-items-stretch">
        <div className="page-content">
          <Sidebar />
          <div className="page_wrapper">
            <div className="container container-custom">
              <div className="row g-3">
                <div className="col-lg-12">
                  <div className="card bal_card_main">
                    {isActiveStep === "step1" && (
                      <>
                        <div className="card-body d-non e">
                          <div className="d-flex align-items-start">
                            <Link to="/dashboard" className="page-header-icon me-2 mt-1">
                              <i className="fa-solid fa-arrow-left fs-3"></i>
                            </Link>
                            <h4 className="mb-4">
                              Withdrawal Amount
                            </h4>
                          </div>
                          <div className="form-group mb-4">
                            <label>Select Chain</label>
                            <select className="form-select" name="chain" value={formData.chain} onChange={handleInput}>
                              <option value="BEP20">BEP20</option>
                              <option value="ERC20">ERC20</option>
                              <option value="TRC20">TRC20</option>
                            </select>
                          </div>

                          <div className="form-group mb-4">
                            <label>Withdrawal to</label>
                            <input type="text" className="form-control" placeholder="Wallet Address" name="withdrawAddress" value={formData.withdrawAddress} onChange={handleInput} />
                          </div>

                          <div className="form-group mb-4">
                            <label>Enter Amount</label>
                            <input type="text" className="form-control" placeholder="Enter Amount" name="amount" value={formData.amount} onChange={(e) => (/^\d*$/.test(e.target.value) && handleInput(e))} />
                          </div>

                          <div className="form-group mb-4">
                            <label>Enter User Pin</label>
                            <div className="field-otp-box">
                              <input type="text" className="form-control" placeholder="Enter user pin" name="userPin" value={formData.userPin}
                                onChange={(e) => (/^\d*$/.test(e.target.value) && handleInput(e))}
                              />

                            </div>
                          </div>

                          <div className="form-group mb-4">
                            <label>Verification Code</label>
                            <div className="field-otp-box">
                              <input className="form-control" id="OTP" type="text" name="verificationCode" placeholder="Enter verification code" value={formData.verificationCode} onChange={(e) => (/^\d*$/.test(e.target.value) && handleInput(e))} onPaste={(e) => e.preventDefault()} />
                              <button className="btn btn-sm btn-gradient" type="button" onClick={() => handleGetOtp('otp')} disabled={isOtpSent}>
                                <span>{isOtpSent ? `Resend in ${countdown}s` : 'GET OTP'}</span>
                              </button>
                            </div>
                          </div>

                          <button type="button" className="btn btn-primary btn-md w-100 btn-block" onClick={handleNextStep}>CONTINUE</button>
                          <div className="d-flex justify-content-end">
                            <Link className="mt-2" to="/forgot-pin">
                              <span className="fs-14">Forgot Pin? Click here</span>
                            </Link>
                          </div>
                        </div>
                      </>
                    )}

                    {isActiveStep === "step2" && (
                      <div className="card-body">
                        <h4 className="mb-4">
                          <button className="btn back_arrow" type="button" onClick={() => setIsActiveStep("step1")}>
                            <i className="ri-arrow-left-line"></i>
                          </button> Final Check
                        </h4>
                        <div className="tt_data mb-4">
                          <div className="tt_item no-border">
                            <span className="text-muted">Chain Name</span>
                            <span className="tt_normal">{formData?.chain}</span>
                          </div>
                          <div className="tt_item no-border">
                            <span className="text-muted">Amount</span>
                            <span className="tt_normal">{formData?.amount}</span>
                          </div>
                          <div className="tt_item no-border">
                            <span className="text-muted">Withdrawal Address</span>
                            <span className="tt_normal">{formData?.withdrawAddress}</span>
                          </div>
                        </div>
                        <button type="button" className="btn btn-primary btn-md w-100 btn-block" onClick={handleWithdrawal}>Withdrawal</button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Withdraw;
